import styles from '../../styles/admin/Main.module.scss'

interface CurriculumLayoutProps {
  children: React.ReactNode
  title: string
}

const CurriculumLayout = ({ children, title }: CurriculumLayoutProps) => {
  return (
    <div className={styles.centerListContainer}>
      <h3 style={{ marginBottom: '30px' }}>{title}</h3>
      {children}
    </div>
  )
}

export default CurriculumLayout
